import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { hermistonConfig } from "./data";

export default function HermistonPage() {
  return <OregonCityPageTemplate config={hermistonConfig} />;
}